import { JSEncrypt } from 'jsencrypt'
export function encrypt(plaintext) {
    // 创建 RSA 加密实例
    var encrypt = new JSEncrypt();
    // 设置 RSA 公钥
    var publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEYgFPf+RXFR9WExDBEeFSbOXnOg9R6zUvz/dDP0dY0emP/xrFS+t5bs0XGi1joRZ30sMbPWWyfAbKPziWaZ+VYuNOsDEyFF2CFZskZi3r3lYicnTns0zGhdtrXb3X+uDNavR1Fik8VnwByo8oWmW+4y5jU5k8AbAWmPlPzCPS4QIDAQAB';
    encrypt.setPublicKey(publicKey);
    // 进行 RSA 加密
    var encrypted = encrypt.encrypt(plaintext);
    return encrypted;
}


// WEBPACK FOOTER //
// ./src/script/tool.js